import { ModuleBucketSize } from './firestore/session';

export interface LayoutSlot {
  size: ModuleBucketSize;
  rowSpan: number; // 1 = single row, 2 = span two rows, etc.
}

export interface LayoutTemplate {
  id: string;
  name: string;
  description: string;
  slots: LayoutSlot[];
}

// Helper to create slots with default rowSpan of 1
const slot = (size: ModuleBucketSize, rowSpan = 1): LayoutSlot => ({ size, rowSpan });

export const LAYOUT_TEMPLATES: LayoutTemplate[] = [
  {
    id: 'hero',
    name: 'Hero',
    description: '2/3 lead + compact grid',
    slots: [
      slot(ModuleBucketSize.TwoThirds, 2),
      slot(ModuleBucketSize.Compact),
      slot(ModuleBucketSize.Compact),
      slot(ModuleBucketSize.Compact),
      slot(ModuleBucketSize.Compact),
      slot(ModuleBucketSize.Compact),
      slot(ModuleBucketSize.Compact),
    ],
  },
  {
    id: 'editorial',
    name: 'Editorial',
    description: '2/3 + stacked sidebar',
    slots: [
      slot(ModuleBucketSize.TwoThirds, 2),
      slot(ModuleBucketSize.Compact),
      slot(ModuleBucketSize.Compact),
      slot(ModuleBucketSize.Compact),
      slot(ModuleBucketSize.Compact),
      slot(ModuleBucketSize.Compact),
    ],
  },
  {
    id: 'gallery',
    name: 'Gallery',
    description: 'Even 4-up grid',
    slots: [
      slot(ModuleBucketSize.Compact),
      slot(ModuleBucketSize.Compact),
      slot(ModuleBucketSize.Compact),
      slot(ModuleBucketSize.Compact),
    ],
  },
  {
    id: 'split',
    name: 'Split',
    description: 'Side by side',
    slots: [slot(ModuleBucketSize.Half), slot(ModuleBucketSize.Half)],
  },
  {
    id: 'featured',
    name: 'Featured',
    description: 'Full banner + 3-up',
    slots: [
      slot(ModuleBucketSize.Full),
      slot(ModuleBucketSize.Compact),
      slot(ModuleBucketSize.Compact),
      slot(ModuleBucketSize.Compact),
    ],
  },
  {
    id: 'showcase',
    name: 'Showcase',
    description: 'Lead left, details right',
    slots: [
      slot(ModuleBucketSize.TwoThirds, 2),
      slot(ModuleBucketSize.Compact),
      slot(ModuleBucketSize.Compact),
      slot(ModuleBucketSize.Compact),
      slot(ModuleBucketSize.Compact),
      slot(ModuleBucketSize.Compact),
    ],
  },
];

export function getTemplateById(id: string): LayoutTemplate | undefined {
  return LAYOUT_TEMPLATES.find((t) => t.id === id);
}
